import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { assertNotFoundError, assertRedirectError } from './assert';
import { IJsonQuerySchema } from '../../repositories/newbuilding-promos/entities/json_query/JsonQuerySchema';
import { ISearchPromosV2ResponseSchema } from '../../repositories/newbuilding-promos/entities/search_promos_v2/SearchPromosV2ResponseSchema';
import { fetchSearchPromos, TSearchPromosResponse } from '../../repositories/newbuilding-promos/v2/search-promos';
import { IJsonQuery } from '../../types/jsonQuery/jsonQuery';
import { ResponseError } from '../../utils/errors';
import { isBrowser } from '../../utils/isBrowser';

export async function resolveSearchPromosPage({
  httpApi,
  logger,
  path,
  jsonQuery,
  subdomain,
}: {
  httpApi: IHttpApi;
  logger: ILogger;
  path?: string;
  jsonQuery?: IJsonQuery;
  subdomain: string;
}): Promise<ISearchPromosV2ResponseSchema> {
  try {
    const response: TSearchPromosResponse = await fetchSearchPromos({
      httpApi,
      config: {
        requestConfig: {
          headers: [['Content-Type', 'application/json']],
        },
      },
      parameters: {
        path,
        jsonQuery: jsonQuery as IJsonQuerySchema,
        subdomain,
      },
    });

    if (response.statusCode !== 200) {
      const { errors, message } = response.response;

      assertNotFoundError(response);

      throw new ResponseError({
        message: message || '',
        domain: 'services.resolveSearchPromosPage',
        details: { errors: JSON.stringify(errors) },
      });
    }

    if (!isBrowser()) {
      assertRedirectError(response.response, { path });
    }

    return response.response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
